import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface SessionTimeoutDialogData {
  countdownSeconds: number;
  expiresAtMs?: number;
}

type SessionTimeoutDialogResult = 'stay' | 'logout' | 'timeout';

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.css']
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  secondsRemaining: number;
  private countdownInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    private dialogRef: MatDialogRef<SessionTimeoutDialogComponent, SessionTimeoutDialogResult>,
    @Inject(MAT_DIALOG_DATA) private data: SessionTimeoutDialogData
  ) {
    this.secondsRemaining = data.countdownSeconds;
  }

  ngOnInit(): void {
    this.updateRemainingFromClock(false);
    this.countdownInterval = setInterval(() => {
      this.updateRemainingFromClock(true);
    }, 1000);
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }

  onStayLoggedIn(): void {
    this.clearCountdown();
    this.dialogRef.close('stay');
  }

  onLogout(): void {
    this.clearCountdown();
    this.dialogRef.close('logout');
  }

  private clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  private updateRemainingFromClock(decrementFallback: boolean): void {
    const expiresAtMs = this.data.expiresAtMs;
    if (typeof expiresAtMs === 'number' && Number.isFinite(expiresAtMs)) {
      this.secondsRemaining = Math.max(0, Math.ceil((expiresAtMs - Date.now()) / 1000));
    } else if (decrementFallback) {
      this.secondsRemaining -= 1;
    }

    if (this.secondsRemaining <= 0) {
      this.clearCountdown();
      this.dialogRef.close('timeout');
    }
  }
}
